import React from "react"
import styled from "styled-components"
import AppleStoreButton from "../../images/product/download-on-the-app-store-apple.svg"
import GoogleStoreButton from "../../images/product/get-on-google-play.svg"
import AppScreenshots from "../../images/product/screenshots.svg"
import { GOOGLE_STORE_LINK, APPLE_STORE_LINK } from "../../utils"

import { Container } from "../global"

const Header = () => {
  return (
    <HeaderWrapper id="top">
      <Container>
        <Flex>
          <HeaderTextGroup>
            <HeaderTexts>
              <Subtitle>Kindness Tracker</Subtitle>
              <h1>Track all your nice actions</h1>
              <h2>
                Use Sookind to reconnect with the kind person you are. <br />
                Get started for <strong>free</strong>.
              </h2>
              <StoreButtons>
                <a
                  href={APPLE_STORE_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StoreButton
                    src={AppleStoreButton}
                    alt="Download on Apple Store"
                  />
                </a>
                <a
                  href={GOOGLE_STORE_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StoreButton
                    src={GoogleStoreButton}
                    alt="Get on Google Play"
                  />
                </a>
              </StoreButtons>
            </HeaderTexts>
          </HeaderTextGroup>
          <ImageWrapper>
            <StyledImage src={AppScreenshots} alt="App Screenshots" />
          </ImageWrapper>
        </Flex>
      </Container>
    </HeaderWrapper>
  )
}

export default Header

const HeaderWrapper = styled.header`
  background-color: ${props => props.theme.color.background.light};
  padding: 160px 0 80px 0;
  position: relative;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 5vw));
  @media (max-width: ${props => props.theme.screen.sm}) {
    padding: 120px 0 40px 0;
  }
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: #54595d;
  letter-spacing: 0px;
  margin-bottom: 16px;

  @media (max-width: ${props => props.theme.screen.sm}) {
    text-align: center;
  }
`

const HeaderTextGroup = styled.div`
  margin: 0;
  margin-top: 56px;

  @media (max-width: ${props => props.theme.screen.sm}) {
    margin-top: 0px;
  }

  > div {
    margin-bottom: -4.5%;

    @media (max-width: ${props => props.theme.screen.md}) {
      margin: 0 16px;
    }
  }

  h1 {
    margin: 0 0 24px;
    color: ${props => props.theme.color.primary};
  }

  h2 {
    margin-bottom: 24px;
    ${props => props.theme.font_size.regular};
    font-weight: 500;
    line-height: 32px;
  }

  p {
    margin-bottom: 48px;
  }

  a {
    text-decoration: none;
  }
`

const Flex = styled.div`
  display: grid;
  justify-content: space-between;
  align-content: center;
  grid-template-columns: 1fr 1fr;
  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    grid-gap: 64px;
  }
`

const HeaderTexts = styled.div`
  align-self: center;
`
const ImageWrapper = styled.div`
  justify-self: end;
  align-self: center;
  @media (max-width: ${props => props.theme.screen.sm}) {
    justify-self: center;
  }
`

const StyledImage = styled.img`
  width: 400px;
  @media (max-width: ${props => props.theme.screen.md}) {
    width: 115%;
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    width: 100%;
  }
`

const StoreButtons = styled.div`
  justify-self: start;
  align-self: center;
  display: grid;
  justify-items: start;
  grid-template-columns: 1fr 1fr;
  margin: 0px;
  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    justify-items: center;
    padding: 0 0px;
  }
`

const StoreButton = styled.img`
  width: 14em;
  height: 4em;
  @media (max-width: ${props => props.theme.screen.sm}) {
    height: 6em;
    padding: 0 0px;
  }
`
